import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "custom-event-polyfill";
import ErrorBoundary from "./components/ErrorBoundary";
import LiveAgent from "./liveAgent/App";
import React from "react";
import ReactDOM from "react-dom";
import SoundController from "./lib/SoundController";
import SttController from "./lib/SttController";
import Widget from "./components/Widget";

if (
  window.location.protocol === "https:" ||
  process.env.REACT_APP_ENV !== "production"
) {
  if (process.env.REACT_APP_INTERFACE_TYPE === "agent") {
    const widgetRoot = document.createElement("div");
    widgetRoot.setAttribute("id", "hyro-root");
    document.body.appendChild(widgetRoot);
    ReactDOM.render(<LiveAgent />, widgetRoot);
  } else {
    const widgetRoot = document.createElement("div");
    widgetRoot.setAttribute("id", "hyro-root");
    document.body.appendChild(widgetRoot);
    ReactDOM.render(
      <ErrorBoundary>
        <Widget
          id={window.HYRO_WIDGET_ID || window.WIDGET_ID}
          sttController={new SttController()}
          soundController={new SoundController()}
        />
      </ErrorBoundary>,
      widgetRoot
    );
  }

  window.hyroSendExternalTextInput = (text) => {
    window.dispatchEvent(
      new CustomEvent("hyro-external-text-input", { detail: { text } })
    );
  };

  window.hyroOpenWidget = () => {
    window.dispatchEvent(
      new CustomEvent("hyro-external-text-input", { detail: {} })
    );
  };
}
